<template>
  <v-container
    d-flex
    align-content-center
    fill-height
    fluid
    style="height: 100vh"
    class="pt-0"
  >
    <v-row justify="center">
      <v-col cols="12" sm="12" md="auto" class="pa-4" style="max-width: 100%">
        <node-edit
          :mode="mode"
          :node="node"
          :chain-id="chainId"
          @confirm="$emit('close')"
          @cancel="$emit('close')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NodeEdit from './Overlay/NodeEdit.vue';

export default {
  components: {
    NodeEdit,
  },
  props: {
    chainId: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: '',
    },
    node: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {},
};
</script>

<style></style>
